function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m147.09 216.121-12.09-16.46-12.09 16.46c-.935 1.271-23.156 31.604-45.744 68.94-31.738 52.461-47.166 90.058-47.166 114.939 0 61.153 44.587 110 105 110 60.429 0 105-48.863 105-110 0-24.881-15.428-62.478-47.166-114.939-22.588-37.336-44.81-67.668-45.744-68.94zm32.91 188.879h-30v30h-30v-30h-30v-30h30v-30h30v30h30z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m432.834 285.061c-22.588-37.336-44.81-67.668-45.744-68.94l-12.09-16.46-12.09 16.46c-.935 1.271-23.156 31.604-45.744 68.94-31.738 52.461-47.166 90.058-47.166 114.939 0 61.15 44.587 110 105 110 60.428 0 105-48.863 105-110 0-24.881-15.428-62.478-47.166-114.939zm-12.834 119.939h-90v-30h90z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m187.5 0h-67.5v165h30v-45.388c3.657 2.845 7.51 5.921 11.377 9.137 31.729 26.38 33.623 36.448 33.639 36.548 0 0-.016-.105-.016-.297h30c0-10.242-4.871-26.088-42.852-57.99-.806-.677-1.61-1.346-2.413-2.01h7.766c28.949 0 52.5-23.551 52.5-52.5-.001-28.949-23.552-52.5-52.501-52.5zm0 75h-37.5v-45h37.5c12.406 0 22.5 10.094 22.5 22.5s-10.094 22.5-22.5 22.5z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m300 90h60v75h30v-105h-90v-60h-30v165h30z"
}));

const SvgBloodFactor = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBloodFactor, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/BloodFactor.618bff5d.svg";
export { ForwardRef as ReactComponent };